__turbopack_context__.v({
  "className": "uY0E_a_className",
  "variable": "uY0E_a_variable",
});
